import React, { useState, useEffect } from 'react';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if the cookieConsent cookie is set
    const consentGiven = document.cookie
      .split('; ')
      .find(row => row.startsWith('cookieConsent='));
    if (consentGiven && consentGiven.split('=')[1] === 'true') {
      setIsVisible(false);
    }
  }, []);

  const handleAccept = () => {
    document.cookie = "cookieConsent=true; path=/; max-age=31536000";
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <p>
        We use cookies to improve your experience on our website. By continuing to browse, you agree to our use of cookies. Read our{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>{' '}
        for more information.
      </p>
      <button onClick={handleAccept} className="accept-button">
        Accept
      </button>
    </div>
  );
};

export default CookieBanner;